<template>
  <div class="report-flow-list-wrapper">
     <van-nav-bar
      title="汇报管理提交"
      @click-left="onClickLeft"
    >
      <template #left>
        <van-icon name="arrow-left" size="0.533rem" color="#333333"/>
      </template>
    </van-nav-bar>
    <div class="company-selection" @click="selectCompanyHandler">
      <span>{{ seletionData.company }}</span>
      <i class="iconfont icon-xiangxiajiantou company-arrow"></i>
    </div>
     <div class="date-selection-warpper">
      <div class="date-selection"> 
        <div class="flex-warpper add-border" @click="selectDateHandler">
          <span>{{ seletionData.selectedDate }}</span>
          <i class="iconfont icon-xiangxiajiantou"></i>
        </div>
      </div>
      <div class="date-show">
        <span>数据截止时间：</span>
        <span class="vei-mid">{{ seletionData.deadlineDate }}</span>
      </div>
    </div>
    <custom-table
      :columns="columns"
      :tableData="tableData"
      @sortFun="sortFun"
      :activeSort="activeSort"
      :bodyHeight="68"
    >
    </custom-table>
    <van-action-sheet v-model="showDatePicker">
      <van-datetime-picker
        v-model="selectedDate"
        type="year-month"
        title="选择年月"
        :formatter="formatter"
        @confirm="dateConfirm"
        @cancel="showDatePicker = false"
      />
    </van-action-sheet>
  </div>  
</template>

<script>
import { getReportPerson } from "@/axios/services"
import CustomTable from "../commonComponents/CustomTable"
import { Toast } from "vant"
export default {
  data () {
    const columns = [
      {
        lable: "名称",
        align: "center",
        prop: "name"
      },
      {
        lable: "提交人数",
        align: "center",
        prop: "personNum",
        isSort: true
      },
      {
        lable: "汇报数量",
        align: "center",
        prop: "approvalNum",
        isSort: true
      },
    ]
    return {
      showDatePicker: false,
      columns,
      seletionData: {
        selectedDate: new Date().getDate() === 1 ? this.getDate("yyyy-MM", "yesterday") : this.getDate("yyyy-MM"),
        deadlineDate: this.getDate('yyyy-MM-dd', 'yesterday'),
        company: "深圳华瀚投资控股有限公司",
        companyId: localStorage.getItem("companyId") === "undefined" ? 
                  "cfe05dd2cedf4dd1ad9475d32838eaf9" : 
                  localStorage.getItem("companyId"),
        officeId: "1aba04d18e1a4f7f9a056c2144b8ac2e",
        scopeType: 0,
        sortType: 0,
        sortStatus: 0
      },
      tableData: [
       
      ],
      selectedDate: new Date().getDate() === 1 ? new Date() - 1000 * 60 * 60 : new Date(),
      activeSort: [],
      selectedCompany: []
    }
  },
  created () {
    // 区分公司排名和个人排名
    if (this.$route.query.id == 4) {
      this.seletionData.sortType = 0
      this.activeSort = [2, true]
    } else if (this.$route.query.id == 5){
      this.seletionData.sortType = 1
      this.activeSort = [1, true]
    }
    this.seletionData.sortStatus = 0
    // this.queryReportPerson()
  },
  beforeRouteEnter(to, from, next) {
    if (from.path === '/select-data-range' || from.path === '/personal-report-board') {
      next(vm => {
        let params = null
        if (from.path === '/select-data-range') {
          params = from.params?.selectedData || []
        } else if (from.path === '/personal-report-board') {
          params = to.query?.seletionData ? JSON.parse(to.query?.seletionData) : []
          let selcetDate = to.query?.selectionDate
          vm.seletionData.selectedDate = selcetDate
          vm.selectedDate = new Date(selcetDate)
        }
        if (params.length) {
          vm.selectedCompany = params
           let selected = params[params.length -1]
          vm.seletionData.company = selected?.name
          vm.seletionData.scopeType = selected?.type
          if (selected.type == 0 || selected.type == 1) {
            vm.seletionData.companyId = selected.id
            vm.seletionData.officeId = ""
          } else if (selected.type == 2) {
            vm.seletionData.companyId = ""
            vm.seletionData.officeId = selected.id
          }
        }
        vm.queryReportPerson()
      });
    } else {
      next()
    }
  },
  methods: {
    getDate (format="yyyy-MM-dd", type) {
      let date = null
      type = type || 'today'
      let now = +Date.now()
      let oneDay = 1000 * 60 * 60 * 24
      let yesterday = now - oneDay
      const typeDes = ["yesterday", "today"]
      if (typeDes.includes(type)) {
        date =  type === 'yesterday' ? new Date(yesterday) : new Date()
      } else {
        date = new Date(type)
      }
      if (date.toString() === 'Invalid Date') {
        return
      } 
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, (RegExp.$1.length == 1) ?
            (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
      }
      return format;
    },
    formatter (type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    onClickLeft () {
      this.$router.back()
    },
    selectCompanyHandler () {
      this.$router.push({
        path: "select-data-range",
        query: {
          seletionData: JSON.stringify(this.selectedCompany)
        }
      })
    },
    sortFun (index, status) {
      this.seletionData.sortType = index === 1 ? 1 : index === 2 ? 0 : ""
      this.seletionData.sortStatus = +status
      this.queryReportPerson()
    },
    dateConfirm (date) {
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      let d = `${y}-${m < 10 ? '0' + m : m}`
      this.showDatePicker = false
      if (this.seletionData.selectedDate === d) {
        return
      }
      this.seletionData.selectedDate = `${y}-${m < 10 ? '0' + m : m}`
      this.queryReportPerson()
    },
    selectDateHandler () {
      this.showDatePicker = true
    },
    async queryReportPerson () {
      let [error, data] = await this.to(getReportPerson({
          scopeType: this.seletionData.scopeType,
          companyId: this.seletionData.companyId,
          officeId: this.seletionData.officeId,
          currentPageSize: -1,
          sortStatus: this.seletionData.sortStatus,
          date: this.seletionData.selectedDate,
          sortType: this.seletionData.sortType
      }))

      if (error) {
        return Toast.fail(error)
      }

      if (data) {
        this.tableData = data
      } 
    },
    to (promise, errorFirst = true) {
      return promise.then(data => {
        let { code, msg, data: res } = data.data
        if (code == 0) {
          return errorFirst ? [null, res] : [null, res]
        } else {
          Toast.fail(msg)
          return errorFirst ? [null, null] : [null, null]
        }
      }).catch(err => {
        return errorFirst ? [err, null] : [null, err]
      }) 
    }
  },
  watch: {
  
  },
  components: {
    CustomTable
  }
}
</script>

<style scoped>
.date-selection-warpper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  height: 44px;
  line-height: 44px;
  padding: 0 16px;
  margin: 10px 0;
}
.date-selection {
  display: flex;
}
.flex-warpper {
 display: flex;
  align-items: center;
}

.flex-warpper:nth-child(1) {
  margin-right: 20px;
}
.company-selection {
  text-align: center;
  position: relative;
  height: 44px;
  background-color: #fff;
  line-height: 44px;
}

.add-border {
   height: 26px;
  border: 1px solid #ddd;
  border-radius:4px;
  padding: 0 8px;
}

.company-arrow {
  font-size: 18px;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
}

.date-selection span {
  color: #666;
  margin-right: 5px;
}

.date-show {
  color: #999;
  font-size: 12px;
}

.vei-mid {
  vertical-align: baseline;
}
</style>